import { Box, InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'end',
  width: '100%',
}));

export const SearchBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  margin: '32px 0',
  alignItems: 'center',
  gap: '30px',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  borderRadius: '32px',
  border: `1px solid ${theme.palette.secondary.main}`,
  padding: '0 18px',
  height: '56px',
  '& .MuiInputBase-input': {
    width: '200px',
    padding: '10px 0 10px',
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('md')]: {
      width: '200px',
      '&:focus': {
        width: '300px',
      },
    },
  },
}));

export const PagesContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  margin: '2rem 0',
}));

export const LoadingBox = styled(Box)(() => ({
  width: '100%',
  marginTop: 16,
}));
